export const PRE_CONFIRM_STATES = ["DRAFT", "INITIATED", "CREATED"];
